import { useCallback, useEffect, useState } from "react";

export default function useFullScreen() {
	const [inFullscreen, setInFullscreen] = useState(false);

	const setFullscreen = useCallback(() => {
		// The page is not in an iframe
		if (!document.fullscreenElement) {
			void document.getElementById("entire_player")?.requestFullscreen();
		} else {
			void document.exitFullscreen();
		}
	}, []);

	useEffect(() => {
		const handleFullscreenChange = () => {
			setInFullscreen(Boolean(document.fullscreenElement));
		};

		document.addEventListener("fullscreenchange", handleFullscreenChange);

		return () => {
			document.removeEventListener("fullscreenchange", handleFullscreenChange);
		};
	}, []);

	return {
		setFullscreen,
		inFullscreen,
	};
}
